import styled from "styled-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes } from "@similarweb/styles";

export const StyledSelectedTableBlock = styled(FlexColumn)`
    height: calc(100vh - 300px);
    overflow: auto;
    padding: 0 24px;
    justify-content: flex-start;
    align-items: center;
    overflow-x: hidden;
    flex-grow: 1;
`;

export const StyledSelectedTableContainer = styled(FlexColumn)`
    width: 100%;
    & > *:not(:last-child) {
        border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    }
`;

export const IntentSelectedTopicItemWrapper = styled.div`
    width: 100%;
    padding: 8px 0;
`;

export const StyledGrandAccessWrapper = styled.div`
    display: flex;
    margin-bottom: 8px;
`;
